//import {AppEventsLogger} from 'react-native-fbsdk';
import firebase from 'firebase/app';

const CCAppEventLogger = {
    logAppEvent(name, params) {
        if(name){
            /*if (AppEventsLogger) {
                AppEventsLogger.logEvent(name, params);
            }*/

            /*if (firebase && firebase.analytics()) {
                firebase.analytics().logEvent(name, params);
            }*/
        }
    },
    logScreenNavigation(screenName, params) {
        if(screenName){
            /*if (AppEventsLogger) {
                AppEventsLogger.logEvent(screenName,{});
            }
*/
            /*if (firebase && firebase.analytics()) {
                firebase.analytics().setCurrentScreen(screenName);
            }*/
        }
    },
    setUserProperties(user) {
        if(user){
            let coins = user.coins ? user.coins.toString() : '';
            let id = user.id;
            let entries =  user.noOfEntries ? user.noOfEntries.toString() : '';
            let entries_won =  user.entriesWon ? user.entriesWon.toString() : '';

            /*if (AppEventsLogger) {
                AppEventsLogger.setUserID(id);
                AppEventsLogger.updateUserProperties({
                    'coins' : coins,
                    'entries' : entries,
                    'entries_won' : entries_won
                })
            }*/

            /*if (firebase && firebase.analytics()) {
                firebase.analytics().setUserId(id);
                firebase.analytics().setUserProperty('coins',coins);
                firebase.analytics().setUserProperty('entries',entries);
                firebase.analytics().setUserProperty('entries_won',entries_won);
            }*/
        }
    },
    clearUserProperties() {
        /*if (AppEventsLogger) {
            AppEventsLogger.setUserID(null);
            AppEventsLogger.updateUserProperties({})
        }*/

        if (firebase && firebase.analytics()) {
            firebase.analytics().setUserId(null);
            firebase.analytics().setUserProperty('coins','');
            firebase.analytics().setUserProperty('entries','');
            firebase.analytics().setUserProperty('entries_won','');
        }
    }
};

export  {CCAppEventLogger};



// WEBPACK FOOTER //
// ./src/app/lib/CCAppEventLogger.js